import { SVGProps } from 'react'

export const ShieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.31897 11.8336L10.9917 13.5063L14.7553 9.74265M8.75225 4.00057L7.67394 4.47981C6.45298 5.02246 5.8425 5.29378 5.39486 5.72266C4.99917 6.10176 4.69662 6.56731 4.51089 7.08286C4.30078 7.66611 4.30078 8.33417 4.30078 9.67028V11.9622C4.30078 13.4441 4.30078 14.185 4.50503 14.8576C4.68585 15.453 4.98229 16.0069 5.3774 16.4876C5.8237 17.0306 6.4402 17.4416 7.6732 18.2636L8.67735 18.9331C9.81605 19.6922 10.3854 20.0718 11.0008 20.2192C11.5446 20.3496 12.1115 20.3496 12.6554 20.2192C13.2707 20.0718 13.8401 19.6922 14.9788 18.9331L15.9829 18.2636C17.2159 17.4416 17.8324 17.0306 18.2787 16.4876C18.6738 16.0069 18.9703 15.453 19.1511 14.8576C19.3553 14.185 19.3553 13.4441 19.3553 11.9622V9.67028C19.3553 8.33417 19.3553 7.66611 19.1452 7.08286C18.9595 6.56731 18.657 6.10176 18.2613 5.72266C17.8136 5.29378 17.2031 5.02246 15.9822 4.47981L14.9039 4.00056C13.7712 3.49716 13.2049 3.24546 12.6162 3.14606C12.0945 3.05795 11.5617 3.05795 11.0399 3.14606C10.4512 3.24546 9.88491 3.49716 8.75225 4.00057Z"
      stroke="#FDFCFD"
      stroke-width="1.59751"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
